import { DateTime } from 'luxon';
import { PlanWebEntity } from './../../../plans/plans-web-repository/entities/plan-web-entity';

export interface MasterPlanWebEntity {
    id: string;
    name: string;
    description: string;
    distributionLaneName: string;
    distributionLaneId: string;
    timeZone: string;
    offSet: number;
    organizationUnitId?: string;
    createdBy: string;
    createdAt: DateTime;
    modifiedAt: DateTime;
    plans: PlanWebEntity[];
    type:number;
    additionalData?: Record<string, string>;
}
